import _WidgetBaseSP from 'more/_WidgetBaseSP';

import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DayRow.html?raw';
import on from 'dojo/on';
import locale from 'dojo/date/locale';
import query from 'dojo/query';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import EvBookingView from '../../EvBookingEditor/EvBookingView';

class DayRow extends compose(_WidgetBaseSP) {
	templateString: any = template;

	_navigationHotkeys: {
		left: "ArrowLeft",
		right: "ArrowRight",
		up: "ArrowUp",
		down: "ArrowDown",
		ctrl: "ControlLeft",
	}

	labelNode: HTMLElement;
	contentNode: HTMLElement;
	groupNode: HTMLElement;
	valueNodeContainer: HTMLElement;
	valueNode: HTMLElement;
	borderNode: HTMLElement;
	staticValueNode: HTMLElement;

	date: Date = null;
	value: string = "";

	staticValue: Array<MCP_booking> = null;
	textValue: string = "";

	backColor: string = "white";
	textColor: string = "white"; //weil es schwarze outlines gibt (siehe css file)
	tooltip: string = "";
	holiday: string = "";
	editable: boolean = false; // (editable == true) == (readonly == false)
	print: boolean = false;
	_editMode: boolean = true;
	_editModeTextArea: HTMLTextAreaElement = null;
	_editModeLastValue: string = "";

	fancyAddApointmentButton: HTMLButtonElement;

	labelAttributeName: string = "";
	groupNodeWidth: number = 0; // number (of px)

	dndNode: HTMLElement = null;

	showTooltips: boolean = true;

	_monthID: string; // for dndData

	dayRowData: Array<object> = []; // Array<{ref_group_ID: string, textValues: Array<{textData}>}>

	_rails: Array<{}> = []; // "Bahnen" für relativ positionierte div's - Array<{railNumber(1,2,3): free/taken(if taken - group) }>
	_appointments: Array<MCP_appointment> = []; // Array<>

	currentlyModifiedAppointment: MCP_currentlyModifiedAppointment = {
		ID: null,
		text: null,
		date: null,
		primaryColor: null,
		secondaryColor: null,
		group: null
	};

	// Methods ---------------------------------------------------

	_isDarkColor(hexValue: string): boolean {
		let color: string;

		if (hexValue.indexOf("#") != 1) color = hexValue.substring(1); // strip #  

		if (color.length > 6) color = color.slice(0, 7); // strip opacity

		let rgb = parseInt(color, 16); // convert rrggbb to decimal  

		let r = (rgb >> 16) & 0xff; // extract red  
		let g = (rgb >> 8) & 0xff; // extract green  
		let b = (rgb >> 0) & 0xff; // extract blue

		var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

		if (luma < 125) { // luma value range is 0..255, where 0 is the darkest and 255 is the lightest  
			return true;
		} else {
			return false;
		}
	}



	_onDrop(evt: any): void {

		let dndData: object = JSON.parse(evt.dataTransfer.getData('text/plain'));

		let message: {} = { dndData: dndData, sender: this }
		//console.log("ONDROP: ", dndData);

		this.emit("DayRow/dnd_drop", message);

		this.UiModder.domStyle.set(this.groupNode, "background-color", "transparent");
		this.UiModder.domStyle.set(this.labelNode, "background-color", "transparent");
		this.UiModder.domClass.remove(this.labelNode, "dndHandle");
		this.UiModder.domClass.remove(this.groupNode, "dndHandle");
	}

	_onDragEnter(evt: any): void {
		let dndData: object = {};
		try{
			dndData = JSON.parse(evt.dataTransfer.getData('text/plain'));
		}catch{
			dndData = JSON.parse(window["monthColumnPlan_dndJson"]);
		}
		let dndID = dndData["dndId"];
		let appointmentNodes = this.domNode.getElementsByClassName("appointment");
		if (appointmentNodes.length > 0) {
			let wasFound = false;
			for (let elem of appointmentNodes as any) {
				if (elem.getAttribute("data-appointment_id") == dndID) {
					wasFound = true;
				}
			}
			if (wasFound == true) {
				return; //style wird nicht im urspruenglichen feld gesetzt
			}
		}

		this.UiModder.domStyle.set(this.groupNode, "background-color", "red");
		//this.UiModder.domStyle.set(this.labelNode, "background-color", "red");
		//this.UiModder.domClass.add(this.labelNode, "dndHandle");
		this.UiModder.domClass.add(this.groupNode, "dndHandle");
	}

	_onDragLeave(evt: Event): void {
		this.UiModder.domStyle.set(this.groupNode, "background-color", "transparent");
		this.UiModder.domStyle.set(this.labelNode, "background-color", "transparent");
		this.UiModder.domClass.remove(this.labelNode, "dndHandle");
		this.UiModder.domClass.remove(this.groupNode, "dndHandle");
	}

	_showTooltips(bool: boolean): void {
		this.showTooltips = bool;

		for (let f = 0; f < this.staticValueNode.children.length; f++) {
			if (this.showTooltips == true) {
				this.UiModder.domClass.add(this.staticValueNode.children[f], "tooltip");
			} else {
				this.UiModder.domClass.remove(this.staticValueNode.children[f], "tooltip");
			}
		}
	}

	_adjustVisibleColumns(message: { event_d: boolean, text_d: boolean }): void {

		if (this.staticValueNode && this.borderNode && this.contentNode) {
			if (message.event_d === false) {
				this.UiModder.domStyle.set(this.staticValueNode, "display", "none");
			} else {
				this.UiModder.domStyle.set(this.staticValueNode, "display", "block");

				//	wenn event_d sichtbar, aber text_d nicht, dann breite anpassen und rahmen ausblenden
				//
				if (message.text_d === false) {

					// remove tooltips
					this._showTooltips(false);

					this.UiModder.domStyle.set(this.staticValueNode, "flex-grow", "1");
					this.UiModder.domStyle.set(this.borderNode, "display", "none");
				}
			}

			if (message.text_d === false) {
				this.UiModder.domStyle.set(this.valueNodeContainer, "display", "none");
				this._showTooltips(false);
			} else {
				this.UiModder.domStyle.set(this.valueNodeContainer, "display", "block");
				this._showTooltips(true);
				//	wenn text_d sichtbar, aber event_d nicht, dann breite anpassen und rahmen ausblenden
				//
				if (message.event_d === false) {
					this.UiModder.domStyle.set(this.valueNodeContainer, "flex-grow", "1");
					this.UiModder.domStyle.set(this.borderNode, "display", "none");
				}
			}

			//	breite 50% wenn beide sichtbar. rahmen anzeigen
			//
			if (message.event_d === true && message.text_d === true) {
				this.UiModder.domStyle.set(this.valueNodeContainer, "flex-grow", "1");
				this.UiModder.domStyle.set(this.staticValueNode, "flex-grow", "0");
				this.UiModder.domStyle.set(this.borderNode, "display", "block");


			} else {

			}
		}
	}

	public requestStaticBookingColorChange(coloringName: string) {
		let altColorings = [];
		for (let sa of this.staticValue){
			let targetColor = "white";//fallback
			//sucht nach coloring Name
			for (let altColoring of sa.alternativeColorations){
				if (altColoring.colorationName == coloringName){
					if (typeof altColoring.coloration != 'undefined'){
						if (altColoring.coloration != null){
							if (altColoring.coloration.indexOf(";") != -1){
								targetColor = altColoring.coloration.split(";")[0];
							}
						}
					}
				}
			}
			altColorings.push(targetColor);
		}
		let counter = 0;
		for (let elem of this.staticValueNode.children as any as Array<HTMLDivElement>){
			elem.style.backgroundColor = "#" + altColorings[counter];
			counter++;
		}
	}

	_setGroupNodeWidth(width: number): void { // number
		this.groupNodeWidth = width;
		let strWidth: string = width + "px";
		if (typeof this.groupNode != 'undefined'){
			if (this.groupNode != null) {
				this.UiModder.domStyle.set(this.groupNode, "width", strWidth);
			}
		}
	}

	isNavigationHotkey(keyCode: string): boolean {
		for (let navKeyCode in this._navigationHotkeys) {
			if (this._navigationHotkeys[navKeyCode] == keyCode) {
				return true;
			}
		}
		return false;
	}
	_onDblClick_DayRow(evt: Event, skipStopPropagation?: boolean): void { // ruft dialog auf
		//frueher durch doppelklick aufrufbar, jetzt nur noch per button
		//setzt animation fuer edit button
		let tmpTarget = (evt.target as HTMLElement).parentElement.parentElement;
		this._UX_AddButton_FocusOUT(({ target: tmpTarget } as any) as Event);
		// doppelklick veröffentlichen
		//

		if (skipStopPropagation != true) {
			evt.stopPropagation();
		}
		let appointment: MCP_appointment = null;
		let appointment_id: string = this.UiModder.domAttr.get(<HTMLElement>evt.target, "data-appointment_id");

		try {
			if (appointment_id.length > 0) {
				for (let appt of this._appointments) {
					if (appt.ID == appointment_id) {
						appointment = appt
					}
				}
			}
		} catch {
			return; //something doesnt work
		}

		this.emit("DayRow/dblClick", {
			date: this.date,
			appointment: appointment,
			sender: this
		});
	}

	// das hier passiert wenn man nicht das appointment div anklickt sonder das content node. sonst - this._onclick_appointmentDiv
	_onClick_ContentNode(evt: Event): void {
		//setzt animation fuer edit button
		let tmpTarget = ((evt.target as any) as HTMLElement).parentElement
		this._UX_AddButton_FocusOUT(({ target: tmpTarget } as any) as Event);

		if (this._appointments.length) {
			let foundIt: boolean = false;

			for (let i = 0; i < this._appointments.length; i++) {
				if (this._appointments[i].GroupId == "" || this._appointments[i].GroupId == null) {
					// wenn das appointment keine gruppe hat
					this._setEditAttr(this.editable, this._appointments[i]);

					foundIt = true;
				}
			}

			if (foundIt == false && this.editable == true) {

				this.set("edit", true);

			}

		} else if (this.editable == true) {
			this.set("edit", true);
		}
	}

	_onClick_AddButton(ev: Event) {
		this._setEditAttr(true, undefined); //-> _setEditAttr()
	}

	_setEditAttr(value: boolean, appointment: MCP_appointment): void {
		this._editMode = value;

		if (this._editMode == true) {
			if (this._editModeTextArea == null) {


				let textValue: string = "";

				if (appointment) {

					this.currentlyModifiedAppointment.ID = appointment.ID;
					this.currentlyModifiedAppointment["text"] = appointment.Description;
					this.currentlyModifiedAppointment.date = appointment["Date"];
					this.currentlyModifiedAppointment.primaryColor = appointment.BackColor;
					this.currentlyModifiedAppointment.secondaryColor = appointment.TextColor;

					// für den moment haben wir keine group.Description und group.primarycolor, aber _onBlur_EditModeTextArea wird das currentlyModifiedAppointment
					// => nach MonthColumn senden, dort müssen wir schauen, dass die Gruppe richtige Farbe + Description bekomt, sonst wird das mit null überschrieben
					if (appointment.GroupId) {
						this.currentlyModifiedAppointment.group = {
							ID: appointment.GroupId,
							description: null,
							primaryColor: null,
							secondaryColor: null,
							tooltip: null
						}
					} else {
						this.currentlyModifiedAppointment.group = {
							ID: null,
							description: null,
							primaryColor: null,
							secondaryColor: null,
							tooltip: null
						}
					}

					let Appt_ID: string = null;
					let appointmentContainerNode: HTMLElement = null;
					let appointmentNodes = query("div .appointment", this.domNode);

					if (appointment.ID) {
						Appt_ID = appointment.ID;
					}

					for (let i = 0; i < appointmentNodes.length; i++) {
						if (appointment.ID == this.UiModder.domAttr.get(<HTMLElement>appointmentNodes[i], "data-appointment_id")) {
							appointmentContainerNode = <HTMLElement>appointmentNodes[i];
						}
					}
					if (appointmentContainerNode) {
						this.UiModder.domAttr.set(appointmentContainerNode, "innerHTML", "");
					}

					if (appointment.Description == null) {
						appointment.Description = "";
					}
					if (typeof appointment.Description == 'undefined') {
						appointment.Description = "";
					}

					textValue = appointment.Description.replace(/(?:\r\n|\r|\n|<br>)/g, '\n');

					let textColor: string = "";
					let apptBackColor: string = "";

					if (appointment.TextColor) {
						textColor = "#" + appointment.TextColor;
					} else {
						apptBackColor = this.convertHex_to_rgba(appointment.BackColor, 70);
						if (apptBackColor) {
							//textColor = this._isDarkColor(apptBackColor) ? "#ffffff" : "#000000";
						}
					}
					
					this._editModeTextArea = <HTMLTextAreaElement>this.UiModder.domConstruct.create("textarea", {
						innerHTML: textValue,
						"data-appointment_id": Appt_ID,
						"maxlength": 50000,
						style: {
							width: "100%",
							border: "none",
							overflow: "hidden",
							resize: "none",
							color: textColor,
							backgroundColor: this.convertHex_to_rgba(appointment.BackColor, 70) // farbe für focus
						}
					}, appointmentContainerNode);

				} else {

					textValue = ""
					let strDayDate: string = locale.format(this.date, {
						selector: "date",
						datePattern: "yyyy-MM-dd"
					});

					this.currentlyModifiedAppointment.ID = null;
					this.currentlyModifiedAppointment["text"] = null;
					this.currentlyModifiedAppointment.date = strDayDate;
					this.currentlyModifiedAppointment.primaryColor = null;
					this.currentlyModifiedAppointment.secondaryColor = null;
					this.currentlyModifiedAppointment.group = {
						ID: null,
						description: null,
						primaryColor: null,
						secondaryColor: null,
						tooltip: null
					}

					this._editModeTextArea = <HTMLTextAreaElement>this.UiModder.domConstruct.create("textarea", {
						innerHTML: textValue,
						"data-appointment_id": null,
						style: {
							width: "95%",
							border: "none",
							overflow: "hidden",
							resize: "none",
							backgroundColor: "#ffffd9" // farbe für focus
						}
					});



					this.UiModder.domConstruct.place(this._editModeTextArea, this.valueNode);

				}

				this._editModeLastValue = this._editModeTextArea.value;
				this._editModeTextArea.focus();
				this._editModeTextArea.setSelectionRange(this._editModeTextArea.value.length, this._editModeTextArea.value.length);

				//	größe der TextArea an Inhalt anpassen
				//
				this._editModeTextArea.style.height = "5px";

				this._editModeTextArea.style.height = (this._editModeTextArea.scrollHeight) + "px";

				//this._editModeTextArea.addEventListener('dblclick', lang.hitch(this, "_onDblClick_DayRow"), false);
				this._editModeTextArea.addEventListener('blur', lang.hitch(this, "_onBlur_EditModeTextArea"), false);
				this._editModeTextArea.addEventListener('keyup', lang.hitch(this, "_onKeyUp_EditModeTextArea"), false);

			}
		}
		else {
			this.refreshDisplayValue();

			if (this._editModeTextArea) {
				this.UiModder.domConstruct.destroy(this._editModeTextArea);
				this._editModeTextArea = null;

			}
		}
	}

	_onKeyDown_DayRow(evt: Event): void {
		// T'ODO: navigation && hotkeys
	}
	_onKeyUp_EditModeTextArea(evt: KeyboardEvent): void {

		//	größe der TextArea an Inhalt anpassen
		//
		this._editModeTextArea.style.height = "5px";
		this._editModeTextArea.style.height = (this._editModeTextArea.scrollHeight) + "px";

		//	bei jeder Änderung den Speichern-Button aktivieren
		//
		if (this.isNavigationHotkey(evt.code) == false) {

			this.emit("saveButtonState", { "disabled": false })

			this.set("value", this._editModeTextArea.value);
		}
	}
	_onBlur_EditModeTextArea(): void {
		if (this._editModeLastValue != this._editModeTextArea.value) {

			if (this._editModeTextArea.value == "" || this._editModeTextArea.value == null) {
				let dlg = new GenericDialog();
				dlg.destroyOnClose = true;
				dlg.show(this.translations["MonthColumnPlan__saveEmptyValueMessage"], this.translations["MonthColumnPlan__deleteAppointmentMessageHeader"], "", "fas fa-info-circle", "okcancel", lang.hitch(this, (res) => {
					if (res == 1) {
						// direkte änderung in dayRow veröffentlichen
						//
						this.currentlyModifiedAppointment["text"] = this._editModeTextArea.value;

						// !!! if ( modifiedAppointment.group.ID) -> modifiedAppointment.group.primaryColor && .descritpion im MonthColumn setzen !!!  
						// Sonst wird das in DB mit null überschrieben!(dayRow kennt die properties nicht)
						this.emit("DayRow/directValueChanged", {
							modifiedAppointment: this.currentlyModifiedAppointment,
							sender: this
						});
						this._onBlur_EditModeTextAreaContinue();
						return;
					} else {
						//	letzten Wert zurücksetzen
						//
						this.set("textValue", this._editModeLastValue);
						this.refreshDisplayValue();

						// kein Speichern notwendig da der alte Wert wiederhergestellt wurde
						//
						this.emit("saveButtonState", { "disabled": true });
						this._onBlur_EditModeTextAreaContinue();
						return;
					}
				}));
				return;
			}
			else {
				// direkte änderung in dayRow veröffentlichen
				//
				this.currentlyModifiedAppointment["text"] = this._editModeTextArea.value;

				this.emit("DayRow/directValueChanged", {
					modifiedAppointment: this.currentlyModifiedAppointment,
					sender: this
				});
				this._onBlur_EditModeTextAreaContinue();
				return;
			}
		}
		this._onBlur_EditModeTextAreaContinue();
	}

	_onBlur_EditModeTextAreaContinue() {
		this.set("edit", false);

		this.currentlyModifiedAppointment = {
			ID: null,
			text: null,
			date: null,
			primaryColor: null,
			secondaryColor: null,
			group: null
		};
	}

	updateAppointments(appointment: MCP_appointment): void {
		if (appointment.ID) {
			let index: number = -1;

			for (let i = 0; i < this._appointments.length; i++) {
				if (this._appointments[i].ID == appointment.ID) {
					index = i;
				}
			}

			if (appointment.Description == "" || appointment.Description == null) {
				if (index >= 0) {
					this._appointments.splice(index, 1);
				}
			} else {
				if (index >= 0) {
					this._appointments[index] = appointment;
				} else {
					this._appointments.push(appointment);
				}
			}

		}

		this.refreshDisplayValue();
	}

	clearDraftColumn(): void {
		this._appointments = [];
		this.refreshDisplayValue();
	}

	processData(dayrowData: MCP_appointment): void {
		if (dayrowData && dayrowData.Type == "draft") {
			// draft datensätze mit groupId werden im monthColumnPlanManager zuerst den gruppen zugewiesen und von dort direckt in die day._appointments gepusht, ...
			if (dayrowData.GroupId == null || dayrowData.GroupId == "") {
				if (this._appointments.length) {

					let index: number = -1;

					for (let i = 0; i < this._appointments.length; i++) {
						if (this._appointments[i].ID == dayrowData.ID) {
							index = i;
						}
					}

					if (index >= 0) {
						this._appointments[index] = dayrowData;
					} else {
						this._appointments.push(dayrowData);
					}

				} else {
					this._appointments.push(dayrowData);
				}
				// ...  day.refreshDisplayValue() verarbeitet danach die _appointments registry of the day // das hier ist nötig für die datensätze ohne gruppenbezug
			} else {

				if (this._appointments.length) {

					let index: number = -1;

					for (let i = 0; i < this._appointments.length; i++) {
						if (this._appointments[i].ID == dayrowData.ID) {
							index = i;
						}
					}

					if (index >= 0) {
						this._appointments[index] = dayrowData;
					} else {
						this._appointments.push(dayrowData);
					}

				} else {
					this._appointments.push(dayrowData);
				}

			}
		}

		this.refreshDisplayValue();
	}

	_setTextValueAttr(value: string): void {
		if (value == null) {
			value = "";
		}

		this.textValue = value.replace(/(?:\r\n|\r|\n)/g, '<br>');

		this.refreshDisplayValue();

	}

	_getEditAttr(): boolean {
		return this._editMode;
	}
	_setBackColorAttr(value: string): void {
		this.backColor = value;
		this.UiModder.domStyle.set(this.labelNode, "backgroundColor", this.backColor);
	}
	_setTextColorAttr(value: string): void {
		this.textColor = value;
		//this.UiModder.domStyle.set(this.labelNode, "color", this.textColor);
	}
	_setLabelAttr(value: string): void {
		this.UiModder.domAttr.set(this.labelNode, "innerHTML", value);
	}
	_setHolidayAttr(value: string): void {
		this.holiday = value;

		//	Feiertage anders darstellen
		//
		if (this.holiday != "" && this.holiday != null) {
			this.UiModder.domStyle.set(this.labelNode, "fontWeight", "bold");
			this.UiModder.domStyle.set(this.domNode, "backgroundColor", "#ff644d");
			this.UiModder.domStyle.set(this.domNode, "color", "#ff644d");
		} else {
			this.UiModder.domStyle.set(this.labelNode, "fontWeight", "");
			this.UiModder.domStyle.set(this.domNode, "backgroundColor", "");
			this.UiModder.domStyle.set(this.domNode, "color", "");
		}
	}
	_getHolidayAttr(): string {
		return this.holiday;
	}
	_setValueAttr(textValue: string): void {
		this.textValue = textValue;
		this.value = textValue;
		//this.refreshDisplayValue();
	}
	_getValueAttr(): Array<MCP_appointment> {
		return this._appointments;
	}

	// Static Value Column -------------------------------------------START

	_assignStaticValue(dayRowData: MCP_booking): void { // this.staticVAlue ist Array<dayRowData>

		if (dayRowData.Type == "static") {

			let index: number = -1;

			for (let i = 0; i < this.staticValue.length; i++) {
				let staticValuObj = this.staticValue[i];

				if (staticValuObj.ID != null && staticValuObj.ID != "" && staticValuObj.ID == dayRowData.ID) {
					index = i;
				}
			}

			if (index >= 0) {
				this.staticValue[index] = dayRowData;
			} else {
				this.staticValue.push(dayRowData);
			}

		} else {
			console.warn("Wrong data assignment (type is not static) at ", this);
		}

		this.refreshDisplayValue();
	}

	_getStaticValueAttr(): Array<MCP_booking> {
		return this.staticValue;
	}
	_getTextValueAttr(): string {
		if (this.textValue == null) {
			return "";
		}
		return this.textValue;
	}

	refreshDisplayValue(): void {
		if (this.valueNode) {
			this.UiModder.domAttr.set(this.valueNode, "innerHTML", "");
		}


		if (this._appointments.length) {

			for (let appointment of this._appointments) {

				let opacity: string = "0.5";
				if (appointment.GroupId && appointment.GroupId.length) {
				} else {
					opacity = "1";
				}
				let textValue: string = appointment.Description;

				let txtColor: string = null;

				if (appointment.TextColor) {
					txtColor = "#" + appointment.TextColor;
				} else {
					txtColor = "#ffffff";//wegen shwarzer umrandung
				}


				if (this._editMode == true && this._editModeTextArea) {
					this.UiModder.domAttr.set(this._editModeTextArea, "innerHTML", textValue);
				}
				else {

					let apptDivContainer: HTMLElement = this.UiModder.domConstruct.create("div", {
						style: {
							"width": "100%",
							"display": "flex",
							"align-items": "stretch"
						},
					}, this.valueNode);

					if (textValue) {
						let appointmentDiv: HTMLElement = this.UiModder.domConstruct.create("div", {

							innerHTML: textValue.replace(/(?:\r\n|\r|\n)/g, '<br>'),
							"class": "appointment",
							"data-appointment_id": appointment.ID,
							style: {
								"padding-left": "5px",
								"width": "95%",
								"border": "none",
								"opacity": opacity,
								"color": txtColor,
								"background-color": this.convertHex_to_rgba(appointment.BackColor, 100)
							}
						}, apptDivContainer);
						appointmentDiv.style.setProperty("color", appointmentDiv.style.color, "important");

						on(appointmentDiv, "click", lang.hitch(this, "_onclick_appointmentDiv"))


						this.dndNode = this.UiModder.domConstruct.create("div", {
							style: {
								"width": "5%",
								"background-color": this.convertHex_to_rgba(appointment.BackColor, 100),
								"cursor": "grab",
								"overflow": "hidden",
								"padding-left": "5px"
							},
							"className": "dndHandle",
							"draggable": true,
							"data-dndLabel": textValue.slice(0, 16) + "...",
							"data-dndId": appointment.ID,
							"data-dndMonth": this._monthID,
							"data-dndType": "appointment",
						}, apptDivContainer, "last");

						on(this.dndNode, "dragstart", function (evt) { // scope: this.dndNode
							this.innerHTML = this.dataset.dndlabel
							this.style.width = "100px";
							let dndJson = JSON.stringify({ dndId: this.dataset.dndid, dndMonth: this.dataset.dndmonth, dndType: this.dataset.dndtype });
							window["monthColumnPlan_dndJson"] = dndJson;
							evt.dataTransfer.setData('text/plain', dndJson);
						});

						on(this.dndNode, "dragend", function (evt) { // scope: this.dndNode
							this.innerHTML = null
							this.style.width = "5%";
						});
					}

				}
			}
		}

		// STATIC STUFF 

		if (this.staticValueNode) {
			this.UiModder.domAttr.set(this.staticValueNode, "innerHTML", null);

			if (this.staticValue.length) {

				let backColor: string = "";
				let textColor: string = "";
				let coloration: string[];

				for (let p = 0; p < this.staticValue.length; p++) {

					let staticValuObj = this.staticValue[p];
					let tooltipClass = "";

					if (this.showTooltips === true) tooltipClass = "tooltip"

					coloration = staticValuObj.coloration ? staticValuObj.coloration.split(";") : [];

					if (coloration.length == 2) {
						backColor = "#" + coloration[0];
						textColor = "#" + coloration[1];
					}

					let staticAppointmentHoverColor = "background-color:" + backColor + "; color:" + textColor + ";";
					let label = this.UiModder.domConstruct.create("div", {
						"innerHTML": staticValuObj[this.labelAttributeName],
						"className": tooltipClass + " staticLabelTxt",
						"style":  staticAppointmentHoverColor, // transparentes backgroud-color, welches on hover angezeigt werden soll
						"data-booking_id": staticValuObj.ID,
					}, this.staticValueNode);

					this.UiModder.domConstruct.create("div", { "className": "tooltiptext", "innerHTML": staticValuObj.activityStatus_description, }, label);

					on(label, "click", lang.hitch(this, function (event) {
						this._onclickStaticData(event);
					}));

					
					/*
					on(label, "mouseover", lang.hitch(this, function (event) {
						this.UiModder.domClass.add(event.target, "w3-card-4")

						this.updateBgColorOpacity(event.target, 1);

					}));

					on(label, "mouseout", lang.hitch(this, function (event) {
						this.UiModder.domClass.remove(event.target, "w3-card-4")

						this.updateBgColorOpacity(event.target, -1);

					}));*/

				}
			}
		}

		// hover edit button
		let removeTargets = this.domNode.getElementsByClassName("appointmentEditButton");
		if (removeTargets.length > 0) {
			for (let elem of removeTargets as any) {
				(elem as HTMLButtonElement).remove();
			}
		}

		let targetElements = this.domNode.getElementsByClassName("appointment");
		if (targetElements.length > 0) {
			let nlCounter = 0; //fuer das zaehlen von newLines
			for (let elem of targetElements as any) {
				let rowMenuButtons = document.createElement("div");
				rowMenuButtons.classList.add("menuButtonRow");
				rowMenuButtons.classList.add("w3-hide");
				rowMenuButtons.style.width = "fit-content";
				rowMenuButtons.style.minWidth = "fit-content";
				rowMenuButtons.style.opacity = "0";

				//holt sich die background color mit opacity vom nachbar element fuer rowMenuButtons bg color
				let bgC = elem.style.backgroundColor;
				bgC = bgC.replace("rgb(", "rgba(");
				let elemOpacity:number = elem.style.opacity;
				if (isNaN(elemOpacity)){
					elemOpacity = 1;
				}
				bgC = bgC.replace(")", " ," + elem.style.opacity + ")");
				rowMenuButtons.style.backgroundColor = bgC; 


				//edit button
				let newEditButton = document.createElement("button");
				newEditButton.classList.add("appointmentEditButton");
				newEditButton.classList.add("hoverBright");
				newEditButton.classList.add("roundest");

				newEditButton.style.background = "transparent";
				newEditButton.style.border = "none";
				newEditButton.style.outline = "none";
				newEditButton.style.minWidth = "fit-content";
				newEditButton.style.maxHeight = "100%";
				newEditButton.style.paddingLeft = "2px";
				newEditButton.style.paddingRight = "2px";

				newEditButton.title = this.translations["MonthColumnPlan__advancedAppointmentEditMenu"];

				let newEditButtonIcon = document.createElement("i");
				newEditButtonIcon.classList.add("fas");
				newEditButtonIcon.classList.add("fa-edit");
				newEditButton.appendChild(newEditButtonIcon);

				newEditButton.addEventListener("click", lang.hitch(this, this._onclickAppointmentEditButton));

				rowMenuButtons.appendChild(newEditButton);

				//sort button
				let sortBtn = [document.createElement("button"), document.createElement("button")];
				let switchBtn = false;
				for (let srtBtn of sortBtn){
					srtBtn.classList.add("sortBtn");
					srtBtn.classList.add("hoverBright");
					srtBtn.classList.add("roundest");

					srtBtn.style.background = "transparent";
					srtBtn.style.border = "none";
					srtBtn.style.outline = "none";
					srtBtn.style.minWidth = "fit-content";
					srtBtn.style.maxHeight = "100%";
					srtBtn.style.paddingLeft = "2px";
					srtBtn.style.paddingRight = "2px";

					let btnIcon = document.createElement("i");
					btnIcon.classList.add("far");
					if (switchBtn){
						//down
						srtBtn.title = this.translations["MonthColumnPlan__sortButtonCell_down"];
						btnIcon.classList.add("fa-arrow-alt-circle-down");
						srtBtn.classList.add("sort-down-btn");
						srtBtn.addEventListener("click", lang.hitch(this, this._onClickSortDownButton) );
					}else{
						//up
						srtBtn.title = this.translations["MonthColumnPlan__sortButtonCell_Up"];
						btnIcon.classList.add("fa-arrow-alt-circle-up");
						srtBtn.classList.add("sort-up-btn");
						srtBtn.addEventListener("click", lang.hitch(this, this._onClickSortUpButton));
					}
					srtBtn.appendChild(btnIcon);
					rowMenuButtons.prepend(srtBtn);
					
					switchBtn = ! switchBtn;
				}

				let currentTarget = (elem as HTMLDivElement);

				currentTarget.parentElement.insertBefore(rowMenuButtons, currentTarget.nextSibling);

				//button UX
				currentTarget.parentElement.addEventListener("touchstart", lang.hitch(this, this.UX_touch_start));
				currentTarget.parentElement.addEventListener("touchend", lang.hitch(this, this.UX_touch_end));
				currentTarget.parentElement.addEventListener("mouseenter", lang.hitch(this, this._UX_AddButton_FocusIN));
				currentTarget.parentElement.addEventListener("mouseleave", lang.hitch(this, this._UX_AddButton_FocusOUT));

				//zaehlt newLines und spalten um herauszufinden, ob am letzten element eine border hinzugefuegt werden soll
				let newLinesInText = (currentTarget.innerHTML).split("<br>").length;
				if (newLinesInText > 0) {
					nlCounter = nlCounter + newLinesInText;
				}
				nlCounter = nlCounter + 1;

				//fuegt borders hinzu
				if (currentTarget.parentElement.classList.contains("appointmentBorder") == false) {

					if (currentTarget.parentElement.parentElement.lastChild !== currentTarget.parentElement) {
						currentTarget.parentElement.classList.add("appointmentBorder");
					} else {
						//should add last element?
						if (nlCounter < 5) {
							currentTarget.parentElement.classList.add("appointmentBorder");
							this.flagRepairAppointmentBorders = false;
						}else{
							this.flagRepairAppointmentBorders = true;
						}
						nlCounter = 0;
					}
				}
				
			}
		}

		this.updateBetterTooltipsForDndHanldes();
		this.sortAppointmentNodes();
		if (this.flagMinimalModeWasUsed){
			if (this.staticValue.length > 0){
				if (this.flagMinimalModeShowEmptyDays){
					if (this.domNode.classList.contains("w3-hide") == true){
						this.domNode.classList.remove("w3-hide");
					}
				}else{
					if (this.domNode.classList.contains("w3-hide") == false){
						this.domNode.classList.add("w3-hide");
					}
				}
			}
		}
	}

	private sortAppointmentNodes(){
		
		let apCollection = (this.valueNode.children);
		let apList:Array<HTMLElement> = [];
		for (let elem of apCollection as any as Array<HTMLElement>){
			apList.push(elem);
		}
		
		(apList).sort(lang.hitch(this, this.sortAppointmentNodesSortFunction));
		
		for (let sortedElement of apList){
			let insertAt:any;
			for (let unsortedElement of apCollection as any as Array<HTMLElement>){
				if (unsortedElement == sortedElement){
					if (apList.indexOf(sortedElement) == 0) {
						insertAt = unsortedElement.parentElement.firstChild;
					}else{
						insertAt = apCollection[apList.indexOf(sortedElement)].nextSibling;
					}
					(unsortedElement.parentElement as Node).insertBefore(unsortedElement, insertAt);
				}
			}
		}

		//verstecken den up/down buttons vom ersten/letzten eintrag
		let firstEntry = this.valueNode.firstChild as HTMLElement;
		let lastEntry = this.valueNode.lastChild as HTMLElement;
		if (typeof firstEntry != 'undefined'){
			if (firstEntry != null){
				let res = firstEntry.querySelectorAll(".sort-up-btn");
				if (res.length > 0){
					(res[0].firstChild as HTMLElement).style.opacity = "0"; //versteckt icon
					(res[0] as HTMLButtonElement).disabled = true;
					(res[0] as HTMLButtonElement).removeAttribute('title');
					(res[0] as HTMLButtonElement).style.cursor = "unset";
					(res[0] as HTMLButtonElement).classList.remove("hoverBright");
				}
			}
		}
		if (typeof lastEntry != 'undefined') {
			if (lastEntry != null) {
				let res = lastEntry.querySelectorAll(".sort-down-btn");
				if (res.length > 0) {
					(res[0].firstChild as HTMLElement).style.opacity = "0"; //versteckt icon
					(res[0] as HTMLButtonElement).disabled = true;
					(res[0] as HTMLButtonElement).removeAttribute('title');
					(res[0] as HTMLButtonElement).style.cursor = "unset";
					(res[0] as HTMLButtonElement).classList.remove("hoverBright");
				}
			}
		}

		//misc. css fixes
		//fixed die appointments border falls noetig
		if (this.valueNode.childElementCount > 0){
			if (this.flagRepairAppointmentBorders){
				let appointmentList = this.valueNode.children;
				for (let ap of appointmentList as any as Array<HTMLElement>){
					if (ap.classList.contains("appointmentBorder") == false){
						ap.classList.add("appointmentBorder");
					}
				}
				let lastElem = (this.valueNode.lastChild as HTMLElement);
				if (lastElem.classList.contains("appointmentBorder")){
					lastElem.classList.remove("appointmentBorder")
				}
			}
		}
		//fixed font text fuer appointments mit gruppe-> outline fuer leesbarkeit
		let apCol = this.valueNode.querySelectorAll("[data-appointment_id]");
		if (apCol.length > 0){
			for (let elem of apCol as any as Array<HTMLElement>){
				let targetID = elem.getAttribute("data-appointment_id");
				//finded das passende appointment
				let hasGroup = true;
				for (let ap of this._appointments){
					if (ap.ID == targetID){
						if (typeof ap.GroupId == undefined){
							hasGroup = false;
						}else{
							if (ap.GroupId == null){
								hasGroup = false;
							}
							if (ap.GroupId == ""){
								hasGroup = false;
							}
						}
					}
				}
				if (hasGroup == true){
					if (elem.classList.contains("whiteTextWithOutline") == false){
						elem.classList.add("whiteTextWithOutline");
					}
				}
			}
		}
	}

	private sortAppointmentNodesSortFunction(a:HTMLElement,b:HTMLElement):number{
		// Return greater than 0 if a is greater than b
		// Return 0 if a equals b
		// Return less than 0 if a is less than b

		// wir sortierne zuerst nach order attribute, -farbe-, groupID , text, ID
		let aA:MCP_appointment;
		let aB:MCP_appointment;
		for (let ap of this._appointments){ //holt das appointment zum Element raus
			if (ap.ID == (a.firstChild as HTMLElement).getAttribute("data-appointment_id")){
				aA = ap;
			}
			if (ap.ID == (b.firstChild as HTMLElement).getAttribute("data-appointment_id")) {
				aB = ap;
			}
		}

		//sortierung nach order
		if ((typeof aA.order == 'undefined') || (aA.order == null)) {
			aA.order = -1; //-1 ist standard order
		}
		if ((typeof aB.order == 'undefined') || (aB.order == null)){
			aB.order = -1; //-1 ist standard order
		}

		if (aA.order < aB.order){
			return 1;
		}
		if (aA.order > aB.order) {
			return -1;
		}

		/*
		//nach farbe sortieren
		let rgbCompareA = 0;
		let rgbCompareB = 0;

		if ((typeof aA.GroupId != 'undefined') && (typeof aB.GroupId != 'undefined')) {
			if ((typeof a.firstChild != 'undefined') && (typeof b.firstChild != 'undefined')) {
				if ((a.firstChild != null) && (b.firstChild != null)) {
					let colorA = getComputedStyle(a.firstChild as HTMLElement).backgroundColor;
					let colorB = getComputedStyle(b.firstChild as HTMLElement).backgroundColor;
					let [rgb_r_A, rgb_g_A, rgb_b_A] = colorA.match(/\d+/g).map(Number);
					let [rgb_r_B, rgb_g_B, rgb_b_B] = colorB.match(/\d+/g).map(Number);
					rgbCompareA = rgb_r_A * 1000000 + rgb_g_A * 1000 + rgb_b_A;
					rgbCompareB = rgb_r_B * 1000000 + rgb_g_B * 1000 + rgb_b_B;
				}
			}
		}
		if (rgbCompareA > rgbCompareB) {
			return 1;
		}
		if (rgbCompareA < rgbCompareB) {
			return -1;
		}
		*/

		//nach gruppe sortieren (wenn groupID gesetzt worden ist)
		let groupA:string = ""; // gruppe sollte groesser sein als leerer string
		let groupB:string = "";
		if (typeof aA.GroupId != 'undefined') {
			if (aA.GroupId != null) {
				groupA = aA.GroupId;
			}
		}

		if (typeof aB.GroupId != 'undefined') {
			if (aB.GroupId != null) {
				groupB = aB.GroupId;
			}
		}

		if (groupA > groupB) {
			return 1;
		}
		if (groupA < groupB) {
			return -1;
		}

		//nach text sortieren
		if ((typeof aA.Description != 'undefined') && (typeof aB.Description != 'undefined')) {
			if ((aA.Description != null) && (aB.Description != null)) {
				if (aA.Description > aB.Description) {
					return 1;
				}
				if (aA.Description < aB.Description) {
					return -1;
				}
			}
		}

		//nach id sortieren
		if (aA.ID > aB.ID) {
			return 1;
		}
		if (aA.ID < aB.ID) {
			return -1;
		}

		console.warn("sorting error");
		console.warn(aA);
		console.warn(aB);
		return 0; //dieser fall sollte eigentlich nicht mehr auftretten, da ID's immer unterschiedlich sein *sollten*
	}

	flagRepairAppointmentBorders = false;
	updateBetterTooltipsForDndHanldes(){
		//bessere hover titles fuer die zellen & dnd stuff
		let apList = this.valueNode.getElementsByClassName("appointment");
		if (apList.length > 0) {
			for (let elem of apList as any as Array<HTMLElement>) {
				elem.title = elem.innerHTML;
			}
		}
		//bessere title/tooltips fuer drag'n'drop handles
		let dndList = this.domNode.getElementsByClassName("dndHandle");
		if (dndList.length > 0) {
			for (let elem of dndList as any as Array<HTMLElement>) {
				let dndType = elem.getAttribute("data-dndtype");
				if (typeof dndType != null) {
					if (dndType == "appointment") {
						elem.title = this.translations["MonthColumnPlan___DragNdrop_tooltip_appointment"];
					}
					if (dndType == "group") {
						elem.title = this.translations["MonthColumnPlan___DragNdrop_tooltip_group"];
					}
				}
			}
		}
	}

	updateBgColorOpacity(elements: HTMLElement | HTMLElement[], change: number): void {

		// Make sure elements is always an Array, so that you can call the
		// function with either an Array of elements or a single one (without
		// having to wrap it in an Array yourself.

		elements = Array.isArray(elements) ? elements : [elements];

		// Process all elements:

		elements.forEach(element => {
			// Get the current background-color value:
			let value = this.UiModder.domStyle.get(element, "background-color");

			// Get all color components (alpha may not be there if = 1):
			let parts: Array<string> = (<string>value).match(/[\d.]+/g);


			// If alpha is not there, add it:
			if (parts.length === 3) {
				parts.push('1');
			}

			// Modify alpha:
			parts[3] = String(Math.min(1, Math.max(0, parseFloat(parts[3]) + change)));

			// Apply new value:
			element.style.backgroundColor = `rgba(${parts.join(',')})`;
		});
	}

	_UX_AddButton_FocusIN(ev: Event) {
		let earlyExit = false;
		if ((typeof this._editModeTextArea == 'undefined') || (this._editModeTextArea == null)) {
			earlyExit = true; //wenn text gerade editiert wird, brauchen wir keinen button
		}
		if (earlyExit == false) {
			return;
		}
		let targetButton = ((ev.target as HTMLElement).getElementsByClassName("menuButtonRow")[0] as HTMLButtonElement);
		if ((typeof targetButton == 'undefined') || (targetButton == null)) {
			return;
		}
		targetButton.style.opacity = "1";
		if (targetButton.classList.contains("w3-hide") == true) {
			targetButton.classList.remove("w3-hide")
		}
	}
	_UX_AddButton_FocusOUT(ev: Event) {
		let targetButton = ((ev.target as HTMLElement).getElementsByClassName("menuButtonRow")[0] as HTMLButtonElement);
		if ((typeof targetButton == 'undefined') || (targetButton == null)) {
			return;
		}
		targetButton.style.opacity = "0";
		if (targetButton.classList.contains("w3-hide") == false) {
			targetButton.classList.add("w3-hide")
		}
	}

	//touch events fuer mobile, bei dopple touch soll das edit menu aufgehen
	flagIsTouching = false;
	flagTouchCounter = 0;
	private UX_touch_start(ev:Event) {
		this.flagIsTouching = true;
		this.flagTouchCounter++;
	}
	private UX_touch_end(ev:Event) {
		this.flagIsTouching = false;
		setTimeout(lang.hitch(this, this.resetTouchCounter),300);
		if (this.flagTouchCounter > 1){//double touch
			let target = ((ev.target as HTMLElement).parentElement).getElementsByClassName("appointmentEditButton")[0];
			if (typeof target == 'undefined'){
				target = ((ev.target as HTMLElement).parentElement.parentElement as HTMLElement).getElementsByClassName("appointmentEditButton")[0];
			}
			try{
				ev.preventDefault();
				ev.stopPropagation();
			}catch{}
			this._onclickAppointmentEditButton({ target: target} as any as Event);
		}
	}
	private resetTouchCounter(){
		if (this.flagTouchCounter > 0){
			this.flagTouchCounter = this.flagTouchCounter - 1;
		}
	}

	_onclickAppointmentEditButton(ev: Event) {
		let targetElement = (ev.target as HTMLButtonElement).parentElement.parentElement.parentElement.children[0];
		try{
			ev.stopPropagation();
		}catch{}
		let id = targetElement.getAttribute("data-appointment_id");
		if ((typeof id == 'undefined') || (id == null)) {
			targetElement = targetElement.firstChild as any;
		}
		this._onDblClick_DayRow((({ target: targetElement } as any) as Event), true);
	}

	_onClickSortDownButton(ev:Event){
		let targetElement = (ev.target as HTMLButtonElement).parentElement.parentElement.parentElement.children[0];
		try {
			ev.stopPropagation();
		} catch { }
		let id = targetElement.getAttribute("data-appointment_id");
		if ((typeof id == 'undefined') || (id == null)) {
			targetElement = targetElement.firstChild as any;
			id = targetElement.getAttribute("data-appointment_id");
		}

		for (let ap of this._appointments){
			if (ap.ID == id){
				let newOrder = ap.order;
				if ((typeof newOrder == 'undefined') || (newOrder == null)){
					newOrder = -1;//default order
				}
				newOrder = newOrder - 1;
				ap.order = newOrder;
				this.updateGroupOrder(ap, this);
			}
		}
	}

	private updateGroupOrder(updated_appointment:MCP_appointment, sender:any){
		this.emit("updateGroupOrder", {
			appointment: updated_appointment,
			sender: sender
		});
	}

	_onClickSortUpButton(ev:Event) {
		let targetElement = (ev.target as HTMLButtonElement).parentElement.parentElement.parentElement.children[0];
		try {
			ev.stopPropagation();
		} catch { }
		let id = targetElement.getAttribute("data-appointment_id");
		if ((typeof id == 'undefined') || (id == null)) {
			targetElement = targetElement.firstChild as any;
			id = targetElement.getAttribute("data-appointment_id");
		}

		for (let ap of this._appointments) {
			if (ap.ID == id) {
				let newOrder = ap.order;
				if ((typeof newOrder == 'undefined') || (newOrder == null)) {
					newOrder = -1;//default order
				}
				newOrder = newOrder + 1;
				ap.order = newOrder;
				this.emit("updateGroupOrder", {
					appointment: ap,
					sender: this
				});
			}
		}
	}

	_onclickStaticData(evt: Event): void {
		let bookingId: string = this.UiModder.domAttr.get(<HTMLElement>evt.target, "data-booking_id");
		let booking: MCP_booking;

		for (let staticValueObj of this.staticValue) {
			if (staticValueObj.ID == bookingId) booking = staticValueObj;
		}

		if (booking) {
			let sDateStart: string;
			let sDateEnd: string;
			let sYear: string;
			let sMonth: string;
			let sDay: string;
			let sHour: string;
			let sMinute: string;

			let value = booking.dateStart;
			if (value) {
				sYear = value.slice(0, 4);
				sMonth = value.slice(5, 7);
				sDay = value.slice(8, 10);
				sHour = value.slice(11, 13);
				sMinute = value.slice(14, 16);
				sDateStart = `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
			} else {
				sDateStart = "N.A."
			}

			value = booking.dateEnd;
			if (value) {
				sYear = value.slice(0, 4);
				sMonth = value.slice(5, 7);
				sDay = value.slice(8, 10);
				sHour = value.slice(11, 13);
				sMinute = value.slice(14, 16);
				sDateEnd = `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
			} else {
				sDateEnd = "N.A."
			}

			let bookingView = new EvBookingView();
			bookingView.showAsDlg(booking.ID, booking.bookingName);
		}
	}

	clearStaticData(): void {
		this.staticValue = [];
		this.UiModder.domAttr.set(this.staticValueNode, "innerHTML", "");
	}

	//wird getriggered, wenn ein bereits erstelltes appointment angeclickt wird
	_onclick_appointmentDiv(evt: Event): void {
		this.UiModder.domStyle.set(<HTMLElement>evt.target, "opacity", "1");

		let appointmentId = this.UiModder.domAttr.get(<HTMLElement>evt.target, "data-appointment_id");

		for (let app of this._appointments) {
			if (app.ID == appointmentId) {
				this._setEditAttr(this.editable, app);
			}
		}

		for (let appointment of this._appointments) {
			if (appointment.ID == appointmentId) this.emit("DayRow/appointmentClick", appointment);
		}
	}

	_highlightGroupAppointments(group_id: string): void {

		for (let appointment of this._appointments) {
			if (appointment.GroupId == group_id) {
				let appointmentNodes = query("div .appointment", this.domNode);
				for (let i = 0; i < appointmentNodes.length; i++) {
					if (appointment.ID == this.UiModder.domAttr.get(<HTMLElement>appointmentNodes[i], "data-appointment_id")) {
						this.UiModder.domStyle.set(<HTMLElement>appointmentNodes[i], "opacity", "1");
					}
				}
			}
		}
	}


	convertHex_to_rgba(hex: string, opacity: number): string { // convertHex('#A7D136',50));
		if (hex && opacity) {
			hex = hex.replace('#', '');
			let r: number = parseInt(hex.substring(0, 2), 16);
			let g: number = parseInt(hex.substring(2, 4), 16);
			let b: number = parseInt(hex.substring(4, 6), 16);

			let result: string = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
			return result;
		}
	}

	getDayLabel(): string {
		if (this.date != null) {
			let label: string = locale.format(this.date, {
				selector: "date",
				datePattern: "dd. EEE"
			});

			return label;
		}
		return "date-error";
	}

	setIsEditable(bool: boolean): void {
		this.editable = bool;
	}
	_setIsEditable(bool: boolean): void {
		this.setIsEditable(bool);
	}

	private _onToggle_AddTextEntry(toggleStatus:boolean){
		if (toggleStatus){
			if (this.fancyAddApointmentButton.classList.contains("w3-hide") == true){
				this.fancyAddApointmentButton.classList.remove("w3-hide");
			}
		}else{
			if (this.fancyAddApointmentButton.classList.contains("w3-hide") == false){
				this.fancyAddApointmentButton.classList.add("w3-hide");
			}
		}
	}

	private flagMinimalModeShowEmptyDays = true;
	private flagMinimalModeWasUsed = false;

	private _onHandle_MinimalModeToggleEmptyDays(t:boolean){
		this.flagMinimalModeShowEmptyDays = t;
	}

	private _onHandle_ActivateMinimalMode(toggle:boolean){
		//group ausblenden
		//leere tage ausblenden
		this.flagMinimalModeWasUsed = true;
		if (toggle){
			if (this.groupNode.classList.contains("w3-hide") == false) {
				this.groupNode.classList.add("w3-hide");
			}
			if (this.valueNodeContainer.classList.contains("w3-hide") == false) {
				this.valueNodeContainer.classList.add("w3-hide");
			}
			if (this.fancyAddApointmentButton.classList.contains("w3-hide") == false) {
				this.fancyAddApointmentButton.classList.add("w3-hide");
				this.fancyAddApointmentButton.disabled = true;
			}
			this.staticValueNode.style.maxHeight = "40px";
			this.staticValueNode.style.width = "100%";
			if ((this.staticValue.length < 1) && (this.flagMinimalModeShowEmptyDays == false)) {
				if (this.domNode.classList.contains("w3-hide") == false) {
					this.domNode.classList.add("w3-hide");
				}
			} else {
				if (this.domNode.classList.contains("w3-hide") == true) {
					this.domNode.classList.remove("w3-hide");
				}
			}
		}else{
			if (this.groupNode.classList.contains("w3-hide") == true) {
				this.groupNode.classList.remove("w3-hide");
			}
			if (this.valueNodeContainer.classList.contains("w3-hide") == true) {
				this.valueNodeContainer.classList.remove("w3-hide");
			}
			if (this.fancyAddApointmentButton.classList.contains("w3-hide") == true) {
				this.fancyAddApointmentButton.classList.remove("w3-hide");
				this.fancyAddApointmentButton.disabled = true;
			}
			this.staticValueNode.style.maxHeight = "unset";
			this.staticValueNode.style.width = "unset";
			if (this.domNode.classList.contains("w3-hide") == true) {
				this.domNode.classList.remove("w3-hide");
			}
		}
	}

	constructor(args) {
        super(...(arguments as unknown as []));
		this._appointments = [];
		this._rails = [];
		this.staticValue = [];
		this.labelAttributeName = "bookingName";
		this.currentlyModifiedAppointment = {
			ID: null,
			text: null,
			date: null,
			primaryColor: null,
			secondaryColor: null,
			group: null
		};
	}

	postCreate(): void {
		super.postCreate.apply(this, arguments as any);

		this._rails = [];

		this.set("label", this.getDayLabel());
		this.set("value", this.value);
		on(this.labelNode, "dragover", function (evt) { evt.preventDefault(); });
		on(this.labelNode, "drop", lang.hitch(this, function (evt) { this._onDrop(evt); }));
		this.domNode.addEventListener("drop", lang.hitch(this, this._onDrop));
		this.domNode.addEventListener("dragend", lang.hitch((ev) => {
			ev.preventDefault(); //damit node drop'able wird
		}));
		this.domNode.addEventListener("dragover", lang.hitch(this, (ev) => {
			ev.preventDefault(); //damit node drop'able wird
		}));
		this.domNode.addEventListener("dragover", lang.hitch(this, (ev) => {
			this._onDragEnter(ev);
		}));
		this.domNode.addEventListener("dragleave", lang.hitch(this, (ev) => {
			this._onDragLeave(ev);
		}))
		//on(this.labelNode, "dragenter", lang.hitch(this, function (evt) { this._onDragEnter(evt); }));
		//on(this.labelNode, "dragleave", lang.hitch(this, function (evt) { this._onDragLeave(evt); }));
		this.fancyAddApointmentButton.title = this.translations["MonthColumnPlan__addNewAppointmentButtonTitle"];
		this.valueNode.title = this.translations["MonthColumnPlan__InsertValueHoverText"];

		let btnList = this.domNode.getElementsByClassName("appointmentEditButton");
		for (let elem of btnList as any) {
			this._UX_AddButton_FocusOUT({ target: elem.parentElement } as any);
		}
		this.on("toggleAddTextEntry", lang.hitch(this, this._onToggle_AddTextEntry));
		this.on("useMinimalMode", lang.hitch(this, this._onHandle_ActivateMinimalMode));
		this.on("minimalModeToggleShowEmptyDays", lang.hitch(this, this._onHandle_MinimalModeToggleEmptyDays));
	}

	startup(): void {
		super.startup.apply(this, arguments as any);
	}
}

export default mdsWidget(DayRow);
